import { Trans, useLingui } from '@lingui/react'

import { TENANT_AT, TENANT_COM } from 'shared/consts'
import IconCircleInfoOutline from 'views/components/atoms/Icon/IconCircleInfoOutline'
import ButtonTransparent from 'views/components/molecules/ButtonTransparent'
import Modal from 'views/components/molecules/Modal'
import ModalShowButton from 'views/components/molecules/ModalShowButton'
import Tenant from 'views/components/utils/Tenant'

export const SearchInformationModal = () => {
  const { i18n } = useLingui()
  return (
    <Tenant tenant={[TENANT_COM, TENANT_AT]}>
      {() => (
        <>
          <ModalShowButton
            component={ButtonTransparent}
            name="search-info"
            small
            modalId="search-info"
            inline
            aria-label={i18n._('searchResults.label.search-info.button.aria')}
            className="u-margin-xx-small--left"
          >
            <IconCircleInfoOutline size="x-small" className="u-color--grey" />
          </ModalShowButton>
          <Modal
            id="search-info"
            className="e-SearchInfoModal"
            title={<Trans id="searchResults.label.infoHeader" />}
            isClientSideControlled
            size="large"
          >
            <Trans
              id="searchResults.label.info"
              components={{
                accentuate: <span className="u-display--block" />,
                accentuateHighlight: <p />,
              }}
            />
          </Modal>
        </>
      )}
    </Tenant>
  )
}
